import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@caos/ca-component-library';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} onClose={onCancel} size="extraSmall" ariaLabel={title}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <p style={{ margin: 0, fontSize: 14, lineHeight: 1.5 }}>{message}</p>
      </ModalBody>
      <ModalFooter>
        <Button size="sm" variant="tertiary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button
          size="sm"
          variant={destructive ? 'primary' : 'primary'}
          onClick={onConfirm}
          style={destructive ? { background: 'var(--error)', borderColor: 'var(--error)' } : undefined}
        >
          {confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
